import { styled } from '@mui/material/styles';

export const DivContentStyled = styled('div', {
  name: 'DivContentStyled',
})(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
